import apinode from '../../apinode'

class IntegracoesService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll() {
    const response = await apinode.get(`/integracoes/${this.idconta}`)

    return response.data
  }
}

export default new IntegracoesService()
